"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toasts = exports.ToastsProvider = void 0;
/*
 * Copyright '2021' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
const toast_model_1 = require("../toast.model");
const toasts_constants_1 = require("../toasts.constants");
class ToastsProvider {
    static getInstance() {
        if (!ToastsProvider.instance) {
            ToastsProvider.instance = new ToastsProvider();
        }
        return ToastsProvider.instance;
    }
    open(toast) {
        const internalToast = new toast_model_1.ToastModel(toast.text, toast.clickAction, toast.clickTarget, toast.severity, toast.dismissAction, toast.dismissTimeout);
        window.dispatchEvent(new CustomEvent(toasts_constants_1.ToastsConstants.TOAST_EVENT_NAME, {
            detail: internalToast
        }));
    }
}
exports.ToastsProvider = ToastsProvider;
exports.Toasts = ToastsProvider.getInstance();
//# sourceMappingURL=toasts.provider.js.map